/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdminInvoicesListResponse } from '../model';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { InvoiceAction } from '../model';
// @ts-ignore
import { InvoiceApprovalDetailResponse } from '../model';
// @ts-ignore
import { InvoiceRefundDetailResponse } from '../model';
// @ts-ignore
import { InvoiceSummaryResponse } from '../model';
// @ts-ignore
import { InvoicesListResponse } from '../model';
/**
 * InvoicesApi - axios parameter creator
 * @export
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Inbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceApprovalDetailInbound: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportInvoiceApprovalDetailInbound', 'id', id)
            const localVarPath = `/v1/invoices/{id}/approvals/inbound/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Outbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceApprovalDetailOutbound: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportInvoiceApprovalDetailOutbound', 'id', id)
            const localVarPath = `/v1/invoices/{id}/approvals/outbound/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Refund)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceApprovalDetailRefund: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportInvoiceApprovalDetailRefund', 'id', id)
            const localVarPath = `/v1/invoices/{id}/approvals/refund/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This generates a new invoice item associated with a specified organization. If it\'s been generated, this API will do nothing.
         * @summary Generate a new invoice
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInvoice: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateInvoice', 'id', id)
            const localVarPath = `/v1/admin/invoices/organizations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns approval details of a specified invoice for income. 
         * @summary Invoice Approval Detail (Inbound)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceApprovalDetailInbound: async (id: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceApprovalDetailInbound', 'id', id)
            const localVarPath = `/v1/invoices/{id}/approvals/inbound`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns approval details of a specified invoice for expense. 
         * @summary Invoice Approval Detail (Outbound)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceApprovalDetailOutbound: async (id: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceApprovalDetailOutbound', 'id', id)
            const localVarPath = `/v1/invoices/{id}/approvals/outbound`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns referral details of a specified invoice for refund.  Refund occurs through dispute processes. 
         * @summary Invoice Approval Detail (Refund)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceApprovalDetailRefund: async (id: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceApprovalDetailRefund', 'id', id)
            const localVarPath = `/v1/invoices/{id}/approvals/refund`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves invoices list.
         * @summary Invoices list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves invoices list for admin.
         * @summary Invoices list for Admin
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceListForAdmin: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns summary detail of a specified invoice for income. 
         * @summary Invoice Summary (Inbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceSummaryInbound: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceSummaryInbound', 'id', id)
            const localVarPath = `/v1/invoices/{id}/summary/inbound`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns summary detail of a specified invoice for expense. 
         * @summary Invoice Summary (Outbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceSummaryOutbound: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceSummaryOutbound', 'id', id)
            const localVarPath = `/v1/invoices/{id}/summary/outbound`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns summary detail of a specified invoice for refund. 
         * @summary Invoice Summary (Refund)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceSummaryRefund: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceSummaryRefund', 'id', id)
            const localVarPath = `/v1/invoices/{id}/summary/refund`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This updates a status of invoice. This action is for admin to update the invoice status.
         * @summary Update invoice status
         * @param {string} id Invoice ID
         * @param {InvoiceAction} invoiceAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceStatus: async (id: string, invoiceAction: InvoiceAction, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateInvoiceStatus', 'id', id)
            // verify required parameter 'invoiceAction' is not null or undefined
            assertParamExists('updateInvoiceStatus', 'invoiceAction', invoiceAction)
            const localVarPath = `/v1/admin/invoices/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = invoiceAction

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesApi - functional programming interface
 * @export
 */
export const InvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Inbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportInvoiceApprovalDetailInbound(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportInvoiceApprovalDetailInbound(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Outbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportInvoiceApprovalDetailOutbound(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportInvoiceApprovalDetailOutbound(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Refund)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportInvoiceApprovalDetailRefund(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportInvoiceApprovalDetailRefund(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This generates a new invoice item associated with a specified organization. If it\'s been generated, this API will do nothing.
         * @summary Generate a new invoice
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateInvoice(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns approval details of a specified invoice for income. 
         * @summary Invoice Approval Detail (Inbound)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceApprovalDetailInbound(id: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceApprovalDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceApprovalDetailInbound(id, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns approval details of a specified invoice for expense. 
         * @summary Invoice Approval Detail (Outbound)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceApprovalDetailOutbound(id: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceApprovalDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceApprovalDetailOutbound(id, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns referral details of a specified invoice for refund.  Refund occurs through dispute processes. 
         * @summary Invoice Approval Detail (Refund)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceApprovalDetailRefund(id: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceRefundDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceApprovalDetailRefund(id, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves invoices list.
         * @summary Invoices list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves invoices list for admin.
         * @summary Invoices list for Admin
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceListForAdmin(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInvoicesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceListForAdmin(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns summary detail of a specified invoice for income. 
         * @summary Invoice Summary (Inbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceSummaryInbound(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceSummaryInbound(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns summary detail of a specified invoice for expense. 
         * @summary Invoice Summary (Outbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceSummaryOutbound(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceSummaryOutbound(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns summary detail of a specified invoice for refund. 
         * @summary Invoice Summary (Refund)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceSummaryRefund(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceSummaryRefund(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This updates a status of invoice. This action is for admin to update the invoice status.
         * @summary Update invoice status
         * @param {string} id Invoice ID
         * @param {InvoiceAction} invoiceAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInvoiceStatus(id: string, invoiceAction: InvoiceAction, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvoiceStatus(id, invoiceAction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvoicesApi - factory interface
 * @export
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesApiFp(configuration)
    return {
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Inbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceApprovalDetailInbound(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportInvoiceApprovalDetailInbound(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Outbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceApprovalDetailOutbound(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportInvoiceApprovalDetailOutbound(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns csv file of a specified invoice for expense. 
         * @summary Export Invoice Approval Detail (Refund)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceApprovalDetailRefund(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportInvoiceApprovalDetailRefund(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This generates a new invoice item associated with a specified organization. If it\'s been generated, this API will do nothing.
         * @summary Generate a new invoice
         * @param {string} id Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInvoice(id: string, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.generateInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns approval details of a specified invoice for income. 
         * @summary Invoice Approval Detail (Inbound)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceApprovalDetailInbound(id: string, page?: number, limit?: number, options?: any): AxiosPromise<InvoiceApprovalDetailResponse> {
            return localVarFp.getInvoiceApprovalDetailInbound(id, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns approval details of a specified invoice for expense. 
         * @summary Invoice Approval Detail (Outbound)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceApprovalDetailOutbound(id: string, page?: number, limit?: number, options?: any): AxiosPromise<InvoiceApprovalDetailResponse> {
            return localVarFp.getInvoiceApprovalDetailOutbound(id, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns referral details of a specified invoice for refund.  Refund occurs through dispute processes. 
         * @summary Invoice Approval Detail (Refund)
         * @param {string} id Invoice ID
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceApprovalDetailRefund(id: string, page?: number, limit?: number, options?: any): AxiosPromise<InvoiceRefundDetailResponse> {
            return localVarFp.getInvoiceApprovalDetailRefund(id, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves invoices list.
         * @summary Invoices list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceList(page?: number, limit?: number, options?: any): AxiosPromise<InvoicesListResponse> {
            return localVarFp.getInvoiceList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves invoices list for admin.
         * @summary Invoices list for Admin
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceListForAdmin(page?: number, limit?: number, options?: any): AxiosPromise<AdminInvoicesListResponse> {
            return localVarFp.getInvoiceListForAdmin(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns summary detail of a specified invoice for income. 
         * @summary Invoice Summary (Inbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceSummaryInbound(id: string, options?: any): AxiosPromise<InvoiceSummaryResponse> {
            return localVarFp.getInvoiceSummaryInbound(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns summary detail of a specified invoice for expense. 
         * @summary Invoice Summary (Outbound)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceSummaryOutbound(id: string, options?: any): AxiosPromise<InvoiceSummaryResponse> {
            return localVarFp.getInvoiceSummaryOutbound(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns summary detail of a specified invoice for refund. 
         * @summary Invoice Summary (Refund)
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceSummaryRefund(id: string, options?: any): AxiosPromise<InvoiceSummaryResponse> {
            return localVarFp.getInvoiceSummaryRefund(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This updates a status of invoice. This action is for admin to update the invoice status.
         * @summary Update invoice status
         * @param {string} id Invoice ID
         * @param {InvoiceAction} invoiceAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceStatus(id: string, invoiceAction: InvoiceAction, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.updateInvoiceStatus(id, invoiceAction, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoicesApi - interface
 * @export
 * @interface InvoicesApi
 */
export interface InvoicesApiInterface {
    /**
     * This returns csv file of a specified invoice for expense. 
     * @summary Export Invoice Approval Detail (Inbound)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    exportInvoiceApprovalDetailInbound(id: string, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * This returns csv file of a specified invoice for expense. 
     * @summary Export Invoice Approval Detail (Outbound)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    exportInvoiceApprovalDetailOutbound(id: string, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * This returns csv file of a specified invoice for expense. 
     * @summary Export Invoice Approval Detail (Refund)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    exportInvoiceApprovalDetailRefund(id: string, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * This generates a new invoice item associated with a specified organization. If it\'s been generated, this API will do nothing.
     * @summary Generate a new invoice
     * @param {string} id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    generateInvoice(id: string, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This returns approval details of a specified invoice for income. 
     * @summary Invoice Approval Detail (Inbound)
     * @param {string} id Invoice ID
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    getInvoiceApprovalDetailInbound(id: string, page?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<InvoiceApprovalDetailResponse>;

    /**
     * This returns approval details of a specified invoice for expense. 
     * @summary Invoice Approval Detail (Outbound)
     * @param {string} id Invoice ID
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    getInvoiceApprovalDetailOutbound(id: string, page?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<InvoiceApprovalDetailResponse>;

    /**
     * This returns referral details of a specified invoice for refund.  Refund occurs through dispute processes. 
     * @summary Invoice Approval Detail (Refund)
     * @param {string} id Invoice ID
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    getInvoiceApprovalDetailRefund(id: string, page?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<InvoiceRefundDetailResponse>;

    /**
     * This retrieves invoices list.
     * @summary Invoices list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    getInvoiceList(page?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<InvoicesListResponse>;

    /**
     * This retrieves invoices list for admin.
     * @summary Invoices list for Admin
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    getInvoiceListForAdmin(page?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<AdminInvoicesListResponse>;

    /**
     * This returns summary detail of a specified invoice for income. 
     * @summary Invoice Summary (Inbound)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    getInvoiceSummaryInbound(id: string, options?: AxiosRequestConfig): AxiosPromise<InvoiceSummaryResponse>;

    /**
     * This returns summary detail of a specified invoice for expense. 
     * @summary Invoice Summary (Outbound)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    getInvoiceSummaryOutbound(id: string, options?: AxiosRequestConfig): AxiosPromise<InvoiceSummaryResponse>;

    /**
     * This returns summary detail of a specified invoice for refund. 
     * @summary Invoice Summary (Refund)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    getInvoiceSummaryRefund(id: string, options?: AxiosRequestConfig): AxiosPromise<InvoiceSummaryResponse>;

    /**
     * This updates a status of invoice. This action is for admin to update the invoice status.
     * @summary Update invoice status
     * @param {string} id Invoice ID
     * @param {InvoiceAction} invoiceAction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    updateInvoiceStatus(id: string, invoiceAction: InvoiceAction, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * InvoicesApi - object-oriented interface
 * @export
 * @class InvoicesApi
 * @extends {BaseAPI}
 */
export class InvoicesApi extends BaseAPI implements InvoicesApiInterface {
    /**
     * This returns csv file of a specified invoice for expense. 
     * @summary Export Invoice Approval Detail (Inbound)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public exportInvoiceApprovalDetailInbound(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).exportInvoiceApprovalDetailInbound(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns csv file of a specified invoice for expense. 
     * @summary Export Invoice Approval Detail (Outbound)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public exportInvoiceApprovalDetailOutbound(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).exportInvoiceApprovalDetailOutbound(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns csv file of a specified invoice for expense. 
     * @summary Export Invoice Approval Detail (Refund)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public exportInvoiceApprovalDetailRefund(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).exportInvoiceApprovalDetailRefund(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This generates a new invoice item associated with a specified organization. If it\'s been generated, this API will do nothing.
     * @summary Generate a new invoice
     * @param {string} id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public generateInvoice(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).generateInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns approval details of a specified invoice for income. 
     * @summary Invoice Approval Detail (Inbound)
     * @param {string} id Invoice ID
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceApprovalDetailInbound(id: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceApprovalDetailInbound(id, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns approval details of a specified invoice for expense. 
     * @summary Invoice Approval Detail (Outbound)
     * @param {string} id Invoice ID
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceApprovalDetailOutbound(id: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceApprovalDetailOutbound(id, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns referral details of a specified invoice for refund.  Refund occurs through dispute processes. 
     * @summary Invoice Approval Detail (Refund)
     * @param {string} id Invoice ID
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceApprovalDetailRefund(id: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceApprovalDetailRefund(id, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves invoices list.
     * @summary Invoices list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves invoices list for admin.
     * @summary Invoices list for Admin
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceListForAdmin(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceListForAdmin(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns summary detail of a specified invoice for income. 
     * @summary Invoice Summary (Inbound)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceSummaryInbound(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceSummaryInbound(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns summary detail of a specified invoice for expense. 
     * @summary Invoice Summary (Outbound)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceSummaryOutbound(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceSummaryOutbound(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns summary detail of a specified invoice for refund. 
     * @summary Invoice Summary (Refund)
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceSummaryRefund(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceSummaryRefund(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This updates a status of invoice. This action is for admin to update the invoice status.
     * @summary Update invoice status
     * @param {string} id Invoice ID
     * @param {InvoiceAction} invoiceAction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public updateInvoiceStatus(id: string, invoiceAction: InvoiceAction, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).updateInvoiceStatus(id, invoiceAction, options).then((request) => request(this.axios, this.basePath));
    }
}
